import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
	CircleSpinner,
	BoxInfo,
	customerDataApiService,
	IApplicationUrlsDto,
	Decision,
	useApplicationData,
	LifeCycleStatus,
	SigningUrlType,
	Status,
} from 'shared/index'
import { Footer, Heading } from '../../../components/index'
import AppDownloadSection from './AppDownloadSection/AppDownloadSection'
import CardSection from './CardSection/CardSection'

import HeaderApplicationPage from '../HeaderApplicationPage/HeaderApplicationPage'

import './cardApplicationPage.scss'
import SignSection from './SignSection/SignSection'
import UploadDocument from './UploadDocument/UploadDocument'

const CardApplicationPage = () => {
	const { t } = useTranslation()

	let applicationId = sessionStorage.getItem('applicationid')
	const [signSuccess, setSignSuccess] = useState(false)
	const [activationSlipnSuccess, setActivationSlipnSuccess] = useState(false)

	const { applicationData, loading, error } = useApplicationData({
		applicationId,
		t,
	})

	const [signingLink, setSigningLink] = useState(
		applicationData?.signingUrls.onlineIdentification.url,
	)

	function checkLifeCycleStatus() {
		switch (applicationData?.lifeCycleStatus) {
			case LifeCycleStatus.DocumentsUpload:
			case LifeCycleStatus.InternalCheck:
			case LifeCycleStatus.IdentificationReceivedId:
				return true
			default:
				return false
		}
	}

	useEffect(() => {
		setSigningLink(applicationData?.signingUrls.onlineIdentification.url)

		async function getSigningUrls() {
			if (
				applicationData?.signingUrls.onlineIdentification.status ===
					Status.NotCreated ||
				applicationData?.signingUrls.onlineIdentification.status ===
					Status.Canceled
			) {
				const data: IApplicationUrlsDto =
					await customerDataApiService.GetSigningUrls(
						+applicationId!,
						SigningUrlType.OnlineIdentification,
						t,
					)
				setSigningLink(data.onlineIdentification)
			}
		}
		getSigningUrls()
		// eslint-disable-next-line
	}, [applicationData, signingLink])

	return (
		<div id="germany" className="card-applicationpage">
			<HeaderApplicationPage />
			<div className="de-page-color">
				{loading ? (
					<div className="col-spinner d-flex justify-content-center align-items-center">
						<CircleSpinner />
					</div>
				) : (
					<>
						<div className="container pt-5">
							{applicationData?.decision ===
								Decision.Rejected && (
								<div className="rejected">
									<Heading
										title={
											t('YourApplication', {
												applicationId,
											}) +
											` ${applicationData?.personalInfo?.firstName} ${applicationData?.personalInfo?.lastName}`
										}
									/>
									<div className="mb-2">
										{t('ApplicationRejected')}
									</div>
								</div>
							)}
							{error && (
								<div className="alert alert-danger">
									{t(error.message)}
								</div>
							)}
						</div>

						{applicationData?.decision !== Decision.Rejected &&
							!error && (
								<>
									<div className="intro-section">
										<div className="container">
											<Heading
												title={
													t('YourApplication', {
														applicationId,
													}) +
													` ${applicationData?.personalInfo?.firstName} ${applicationData?.personalInfo?.lastName}`
												}
												description="ApplicationHeading"
											/>
										</div>
										<CardSection
											applicationData={applicationData}
										/>
									</div>

									<div className="idnow-section">
										{(applicationData?.lifeCycleStatus ===
											LifeCycleStatus.CustomerVerification ||
											applicationData?.lifeCycleStatus ===
												LifeCycleStatus.DocumentsUpload) && (
											<SignSection
												application={applicationData!}
												applicationId={parseInt(
													applicationId!,
												)}
												signingLink={signingLink!}
												success={signSuccess}
												setSuccess={setSignSuccess}
											/>
										)}
									</div>

									<div className="activationslip-section">
										{(checkLifeCycleStatus() ||
											applicationData?.lifeCycleStatus !==
												LifeCycleStatus.Disbursed ||
											signSuccess) && (
											<section className="container mb-5 upload-doc">
												<UploadDocument
													applicationId={parseInt(
														applicationId!,
													)}
													application={
														applicationData!
													}
													success={
														activationSlipnSuccess
													}
													setSuccess={
														setActivationSlipnSuccess
													}
												/>
											</section>
										)}
									</div>

									{activationSlipnSuccess && (
										<div className="container">
											<BoxInfo
												css="success"
												message={t(
													'ActivationslipSuccess',
												)}
											/>
										</div>
									)}

									{applicationData?.lifeCycleStatus ===
										LifeCycleStatus.Disbursed && (
										<AppDownloadSection />
									)}
								</>
							)}
					</>
				)}
			</div>
			<Footer />
		</div>
	)
}

export default CardApplicationPage
